


































import { Component, Vue, Prop, PropSync, Emit } from "vue-property-decorator";
import { Farm } from "@/api/farms/types";
import AnalysesListController from "../analyses-list/AnalysesListController.vue";
import { formattedAreaInHa } from "@/filters/area";
import PolygonViewer from "@/components/wrappedGoogleMaps/PolygonViewer.vue";
import { wrapGeometryObject } from "@/helpers/geojson";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

const COLORS = ["#eecb11", "#fa14ff", "#00fca1", "#0008fc", "#42f5ff"];
const LEN_COLORS = COLORS.length;

@Component({
  name: "FarmItem",
  components: {
    AnalysesListController,
    PolygonViewer,
    AgroIcons,
  },
  filters: {
    formattedAreaInHa,
  },
})
export default class FarmItem extends Vue {
  @Prop({ type: Object, required: true })
  private farm!: Farm;

  @Prop({ type: Number, default: () => Math.floor(Math.random() * LEN_COLORS) })
  private colorIndex!: number;

  private opemConfirmModal: boolean = false;

  private get farmAsPolygon() {
    const props = {
      id: this.farm.uuid,
      title: this.farm.name,
      fill: COLORS[this.colorIndex % LEN_COLORS],
      "fill-opacity": 0.2,
      stroke: COLORS[this.colorIndex % LEN_COLORS],
      "stroke-width": 4,
    };
    return wrapGeometryObject(this.farm.geom, props);
  }

  private sendFarmForAnalysis(analysisType: string) {
    this.$emit("analysis:open", this.farm);
    this.$emit("analysis:type", analysisType);
  }

  private deleteFarm() {
     this.$emit("delete:farm", this.farm);
  }
}
